"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrow_left = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var arrow_left = function arrow_left(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'arrow-left-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M6.841 6.53033C7.13389 6.23744 7.13389 5.76256 6.841 5.46967C6.54811 5.17678 6.07323 5.17678 5.78034 5.46967L1.78034 9.46967L1.25001 10L1.78034 10.5303L5.78034 14.5303C6.07323 14.8232 6.54811 14.8232 6.841 14.5303C7.13389 14.2374 7.13389 13.7626 6.841 13.4697L4.12133 10.75L18.3107 10.75C18.7249 10.75 19.0607 10.4142 19.0607 10C19.0607 9.58579 18.7249 9.25 18.3107 9.25L4.12133 9.25L6.841 6.53033Z',
    fill: '#4B5563'
  }));
};

exports.arrow_left = arrow_left;